import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { AgentPlatformSurface, IAgentProfileListView } from './types';

// The WORKFLOW_NODE surface is role-gated in the service (workflow-authoring permission) and
// answers 403 otherwise, so a caller should distinguish that from a transport failure.
export const useAgentProfiles = (options?: {
  surface?: AgentPlatformSurface;
  enabled?: boolean;
}) => {
  const query = new URLSearchParams();
  if (options?.surface) query.append('surface', options.surface);

  const search = query.toString();
  const isEnabled = options?.enabled ?? true;

  const { data, error, isLoading, mutate } = useSWR<IAgentProfileListView>(
    isEnabled ? `agent/profiles${search ? `?${search}` : ''}` : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    profiles: data?.profiles,
    count: data?.count,
    error,
    isLoading,
    mutate,
  };
};
